import { storageKeys } from '../constants';

const clearStorage = () => {
  Object.values(storageKeys).forEach((key) => {
    if (
      key !== storageKeys.CLIENT_ID
    ) {
      localStorage.removeItem(key);
    }
  });
};

export default clearStorage;
